export default __webpack_public_path__ + "static/media/home-freelancer-img-05.1f275113.png";